import { render, staticRenderFns } from "./health-facility-profile.vue?vue&type=template&id=64c1517e&scoped=true"
import script from "./health-facility-profile.vue?vue&type=script&lang=js"
export * from "./health-facility-profile.vue?vue&type=script&lang=js"
import style0 from "./health-facility-profile.vue?vue&type=style&index=0&id=64c1517e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c1517e",
  null
  
)

export default component.exports